import {
  setPlayerDebugMode,
  setLogger as setPlayerLogger,
} from '@setplex/pureya'
import { api } from '@setplex/tria-api'
import {
  adapter,
  clearPageReuseCache,
  setLogger as setAdapterLogger,
  SUBSCRIBER_CACHE_TAG,
} from '@setplex/tria-api-adapter-nora'
import { createEffect, createEvent, sample } from 'effector'
import { env } from '~/shared/config'
import { LEVELS, Logger } from '~/shared/logger'
import { deviceModel } from '../device'
import { cacheController } from './cache'
import { client, controller } from './client'

api.use(adapter({ $deviceType: deviceModel.$deviceType, client }))

/**
 * Event to be notified of any change in blacklisted api groups
 */
export const onBucketsUpdate = createEvent()

controller.subscribe(() => onBucketsUpdate())

/**
 * Drop cached responses of the previous subscriber or profile.
 * Cache keys are URL shaped, so nothing else separates them.
 * Guest → registered sign-in has no sign-out, so sign-in and guest-in
 * must drop tagged entries too. `session.reset` covers getAccountFx.fail
 * and a persisted accountNumber becoming null. Translations stay cached.
 */
const invalidateSubscriberCacheFx = createEffect(() => {
  clearPageReuseCache()
  return cacheController.invalidateWhere(
    (entry) => entry.tags?.includes(SUBSCRIBER_CACHE_TAG) ?? false
  )
})

sample({
  clock: [
    api.session.signInFx.done,
    api.session.guestInFx.done,
    api.session.signOutFx.done,
    api.session.reset,
    api.events.http.unauthorized,
    api.profiles.updateProfileActiveStateFx.done,
  ],
  target: invalidateSubscriberCacheFx,
})

/**
 * Get current Request Policy status,
 * either it is enforced for some request groups or not
 */
export function isRequestPolicyEnforced(): boolean {
  return controller.isEnforced()
}

// set logger for a adapter and player
setAdapterLogger(new Logger('adapter', undefined, LEVELS.error))
setPlayerLogger(new Logger('player', undefined, LEVELS.error))

// set debug mode for player errors
if (env.TRIA_CLIENT_PLAYER_DEBUG) {
  setPlayerDebugMode(env.TRIA_CLIENT_PLAYER_DEBUG)
}
